import { CountryTaxRatesTable } from "@/components/CountryTaxRatesTable";

export function CountryTaxRatesPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-2 text-2xl font-bold">Country Tax Table</h1>
      <p className="text-muted-foreground mb-6 text-sm">
        Platform-managed default tax rates per country with effective-date windows.
        Snapshots on sent invoices freeze whichever row was in force at issue date.
      </p>
      <CountryTaxRatesTable />
    </div>
  );
}
